import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Button } from '@piplapps/pipl-ui';
import LoadingButton from '../../../Components/LoadingButton';
import styles from './RedirectModal.module.less';

const RedirectModal = (props) => {
  return (
    <div className={styles.modalContainer}>
      <span tabIndex={0} role="button" className={styles.close} onClick={props.close}>
        &times;
      </span>
      <div className={styles.bodyContainer}>
        <div className={styles.header}>{gettext('You Have No Organization Details')}</div>
        <div className={styles.text}>
          {gettext(
            'In order to add a credit card you must enter your organization billing details. Would you like to do this now?',
          )}
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <LoadingButton
          buttonClass="primary-blue"
          type="submit"
          onClick={props.redirect}
          text={gettext('Yes')}
          width="39%"
          id="submit-button"
        />
        <Button
          buttonClass="secondary-blue"
          onClick={props.close}
          text={gettext('No')}
          width="39%"
          id="cancel-button"
          margin={{ marginLeft: '15px' }}
        />
      </div>
    </div>
  );
};

RedirectModal.propTypes = {
  close: PropTypes.func,
  redirect: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RedirectModal);
